<div class="h-100 single-report-page">
    <app-admin-report [columns]="report" [hasFilters]="true" [apiUrl]="reportAPI"
                      [dataInterceptor]="addTotal" [isPdfRemove]="false"
                      reportTitle="ADMINISTRATION.ACTIVITY_ADMINISTRATIVE_REPORT_TITLE">
    </app-admin-report>
</div>
